module.exports = __webpack_public_path__ + "img/kunden.a2d4e2de.png";